import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { Spinner } from './components'
import { Route, Switch } from 'react-router-dom'
import { ResidentsView, DocumentsView, RentIntentionView, FinancialView, StartView, ContractView } from './views'
import * as routeService from './services/routeService'
import { getApplicationProfile } from './actions/FlowAction'
import { userSchema } from './utils/user'

export const routes = () => (
  <Switch>
    <Route exact path={`/bewoners`} component={ResidentsView} />
    <Route exact path={`/huurintentie`} component={RentIntentionView} />
    <Route exact path={`/huurcontract`} component={ContractView} />
    <Route exact path={`/inkomsten`} component={FinancialView} />
    <Route exact path={`/documenten`} component={DocumentsView} />
    <Route exact path={`/start`} component={StartView} />
  </Switch>
)

class AppProperty extends Component {
  componentDidMount = async () => {
    try {
      const { user } = this.props

      const isValid = userSchema.isValidSync(user)

      if (!isValid) {
        routeService.goToPageInternal('/register', { replace: true })
      } else {
        await this.props.getApplicationProfile(this.props.user)
        this.goToCorrectRouteForPhase()
      }
    } catch (err) {
      routeService.goTo404()
    }
  }

  goToCorrectRouteForPhase = () => {
    let { step, completedAt, finishedStep } = this.props

    routeService.redirectByPhase(step, completedAt, finishedStep)
  }

  render() {
    const { match, applicationProfileSuccess } = this.props
    return (
      <Fragment>
        {!applicationProfileSuccess && <Spinner size="large" />}
        {applicationProfileSuccess && routes(match)}
      </Fragment>
    )
  }
}

AppProperty.propTypes = {
  match: PropTypes.object,
  getApplicationProfile: PropTypes.func,
  user: PropTypes.object,
  applicationProfileSuccess: PropTypes.bool,
  finishedStep: PropTypes.object,
  step: PropTypes.any,
  isFirstApplication: PropTypes.any,
  completedAt: PropTypes.any,
}

const mapStateToProps = ({ FlowReducer, AuthReducer }) => {
  const {
    application: { finishedStep },
    applicationProfileSuccess,
    step,
    completedAt,
    isFirstApplication,
  } = FlowReducer
  const { user } = AuthReducer
  return {
    applicationProfileSuccess,
    user,
    step,
    completedAt,
    finishedStep,
    isFirstApplication,
  }
}
const mapDispatchToProps = dispatch => ({
  getApplicationProfile: (propertyId, user) => dispatch(getApplicationProfile(propertyId, user)),
  resetStores: () => dispatch({ type: 'RESET' }),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AppProperty)



// WEBPACK FOOTER //
// ./src/AppVisitors.js